import { createContext, useContext, useEffect, useState, useCallback } from "react";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mbv_wishlist") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("mbv_wishlist", JSON.stringify(items));
  }, [items]);

  const has = useCallback((id) => items.some((i) => i.id === id), [items]);

  const toggle = useCallback((product) => {
    setItems((prev) => {
      if (prev.some((i) => i.id === product.id)) {
        return prev.filter((i) => i.id !== product.id);
      }
      return [
        ...prev,
        {
          id: product.id,
          name: product.name,
          price: product.is_offer && product.offer_price ? product.offer_price : product.price,
          image: product.image,
        },
      ];
    });
  }, []);

  const remove = useCallback((id) => {
    setItems((prev) => prev.filter((i) => i.id !== id));
  }, []);

  const count = items.length;

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, count, open, setOpen }}>
      {children}
    </WishlistContext.Provider>
  );
}
